<app-teranet-no-pin *ngIf="!primary"></app-teranet-no-pin>

<div *ngIf="primary" class="flex justify-center flex-col items-center">
	<h4 *ngIf="!showBackButton" class="mr-2 self-start w-full pb-2">
		Adjacent Lots | PIN: {{ selectedPin?.pin }}
	</h4>
	<div
		*ngIf="mapPurchaseStates[selectedPin?.pin]?.state === purchaseStates.ERROR"
		class="flex flex-1 flex-col justify-center items-center"
	>
		<div class="text-red">Error Purchasing Map. Please retry</div>
	</div>

	<div
		*ngIf="!selectedPin?.parent"
		class="flex flex-1 mt-20 justify-center items-center"
	>
		<div>Maps purchases are only available for parent PINs.</div>
	</div>

	<div class="flex flex-col items-center">
		<div
			*ngIf="
				selectedPin.parent &&
				!selectedPin?.map?.uploaded_document_path &&
				(mapPurchaseStates[selectedPin?.pin]?.state !==
					purchaseStates.PURCHASING ||
					mapPurchaseStates[selectedPin?.pin]?.state === purchaseStates.ERROR)
			"
			class="flex flex-1 flex-col justify-center items-center"
		>
			<div
				*ngIf="!selectedPin?.partLot"
				class="flex flex-col justify-center items-center"
			>
				<app-icon
					[icon]="ICON.FULL_PARCEL"
					class="text-8xl text-gray-400 mb-10"
					[testHook]="testHooks.FullParcelIcon"
				></app-icon>
				This lot is a full lot. It is not required to purchase the map
			</div>
			<div
				*ngIf="selectedPin?.partLot"
				class="flex flex-col justify-center items-center gap-1"
			>
				<span class="text-xl">This Lot is A Part Lot</span>
				<span> It's advisable to purchase the map.</span>
			</div>
		</div>

		<ui-button
			class="mt-4"
			label="Purchase map"
			preset="HIGH_EMPHASIS"
			(click)="purchaseMap()"
			teranetLoginGuard
			[loading]="
				!selectedPin?.map &&
				mapPurchaseStates[selectedPin?.pin]?.state === purchaseStates.PURCHASING
			"
			*ngIf="selectedPin?.map?.uploaded_document_path?.length <= 0"
			[testHook]="testHooks.PurchaseMapButton"
		></ui-button>
		<img
			*ngIf="
				selectedPin?.partLot &&
				selectedPin?.map?.uploaded_document_path?.length <= 0
			"
			class="max-w-64 mt-14"
			src="/assets/images/empty-states/undraw-my-current-location.svg"
		/>
	</div>

	<div
		class="flex flex-1 flex-col min-w-full"
		*ngIf="selectedPin?.map?.uploaded_document_path?.length > 0"
	>
		<div *ngIf="showBackButton" class="flex my-10 justify-between items-end">
			<div class="flex gap-2">
				<h4>
					<span
						class="text-green cursor-pointer hover:underline"
						(click)="goBackToOverview()"
						>Overview </span
					>/ Adjacent lots for PIN: {{ selectedPin.pin }}
				</h4>
			</div>
			<app-radio-group
				label="Select type"
				[items]="lotViewStateFilterOptions"
				type="compact"
				[ngModel]="lotViewState"
				(ngModelChange)="setLotViewState($event)"
				[testHook]="testHooks.SelectTypeRadioGroup"
			></app-radio-group>
		</div>
		<div class="flex mb-10" *ngIf="!showBackButton">
			<app-radio-group
				label="Select type"
				[items]="lotViewStateFilterOptions"
				type="compact"
				[ngModel]="lotViewState"
				(ngModelChange)="setLotViewState($event)"
				[testHook]="testHooks.SelectTypeRadioGroup1"
			></app-radio-group>
		</div>

		<div class="grid grid-cols-3 gap-4 h-full">
			<div class="border rounded-md p-4 shadow-md">
				<div class="flex justify-end">
					<app-button
						(click)="expandImage()"
						btn="tertiary"
						[icon]="ICON.EXPAND"
						[testHook]="testHooks.ExpandImageButton"
					></app-button>
				</div>
				<div id="adjacent-lot-map">
					<img [src]="imageSrc" />
				</div>
			</div>

			<div class="col-span-2">
				<app-teranet-map-lots
					*ngIf="lotViewState === lotViewStates.PART"
					[lots]="partLots"
					[testHook]="testHooks.TeranetMapPartLots"
				></app-teranet-map-lots>

				<app-teranet-map-lots
					*ngIf="lotViewState === lotViewStates.FULL"
					[lots]="fullLots"
					[testHook]="testHooks.TeranetMapFullLots"
				></app-teranet-map-lots>

				<app-teranet-map-lots
					*ngIf="lotViewState === lotViewStates.OTHER"
					[lots]="otherLots"
					[testHook]="testHooks.TeranetMapOtherLots"
				></app-teranet-map-lots>
				<app-teranet-map-lots
					*ngIf="lotViewState === lotViewStates.ALL"
					[lots]="allLots"
					[testHook]="testHooks.TeranetMapAllLots"
				></app-teranet-map-lots>
			</div>
		</div>
	</div>
</div>
